import { Fragment } from 'react';

import {
	Empty,
	EmptyActions,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyTitle,
} from '@playbooks/ui/components/empty';
import { EmptyMedia } from '@playbooks/ui/components/empty';
import { Icon, resolveIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import type { FeedbackInternalProps } from './types';
import { cva } from 'class-variance-authority';

const modalFeedbackIconVariants = cva('text-4xl', {
	variants: {
		variant: {
			default: 'text-foreground-body',
			success: 'text-success',
			destructive: 'text-danger',
		},
	},
	defaultVariants: { variant: 'default' },
});

const ModalFeedback = ({ icon, title, text, actions, variant, className }: FeedbackInternalProps) => {
	// Theme
	const rootClassName = cn('p-4', className);
	const iconClassName = modalFeedbackIconVariants({ variant });

	// Render
	return (
		<Fragment>
			<Empty className={rootClassName}>
				<EmptyHeader className='px-4 pt-4'>
					{icon && (
						<EmptyMedia className={iconClassName}>
							<Icon {...resolveIcon(icon, 'fad')} aria-hidden />
						</EmptyMedia>
					)}
				</EmptyHeader>
				<EmptyContent>
					{title && <EmptyTitle>{title}</EmptyTitle>}
					{text && <EmptyDescription>{text}</EmptyDescription>}
				</EmptyContent>
			</Empty>
			{actions && <EmptyActions className='flex-between gap-4 py-4 w-full'>{actions}</EmptyActions>}
		</Fragment>
	);
};
export { ModalFeedback };
